// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1gOLC","copyright":"Footer_copyright__a9Cp9"};